import React, { useState } from "react";
import "./ActionButtons.css";

function ActionButtons({ setModalData }) {

  const [activeBtn, setActiveBtn] = useState("X1");

  // Logic for Big and Small buttons
  const handleSelectionClick = (value) => {
    const type = value === "Big" ? "orange" : "blue";

    if (setModalData) {
      setModalData({
        open: true,
        value: value,
        type: type
      });
    }
  };

  const handleMultiplierClick = (value) => {
    setActiveBtn(value);
  };

  return (
    <>
      <section className="ActionButtons">

        <div className="random_buttons">
          <button
            className={`random_btn ${activeBtn === "Random" ? "active" : ""}`}
            onClick={() => handleMultiplierClick("Random")}
          >
            Random
          </button>

          <button
            className={activeBtn === "X1" ? "active" : ""}
            onClick={() => handleMultiplierClick("X1")}
          >
            X1
          </button>

          <button
            className={activeBtn === "X5" ? "active" : ""}
            onClick={() => handleMultiplierClick("X5")}
          >
            X5
          </button>

          <button
            className={activeBtn === "X10" ? "active" : ""}
            onClick={() => handleMultiplierClick("X10")}
          >
            X10
          </button>

          <button
            className={activeBtn === "X20" ? "active" : ""}
            onClick={() => handleMultiplierClick("X20")}
          >
            X20
          </button>
        </div>

        <div className="big_small">
          <button
            className="big_btn big_btn_holder"
            onClick={() => handleSelectionClick("Big")}
          >
            Big
          </button>

          <button
            className="small_btn big_btn_holder"
            onClick={() => handleSelectionClick("Small")}
          >
            Small
          </button>
        </div>

      </section>
    </>
  );
}

export default ActionButtons;